import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { MutationKey, QueryKey } from '@shared/config';
import type { TFormErrorResponse } from '@shared/types';
import { companyApi } from '../companyApi';
import type { Company, ConfirmCompanyNccResponse } from '../types';

export const useConfirmCompanyNcc = () => {
  const queryClient = useQueryClient();

  return useMutation<
    ConfirmCompanyNccResponse,
    AxiosError<TFormErrorResponse>,
    string
  >({
    mutationKey: [MutationKey.CONFIRM_COMPANY_NCC],
    mutationFn: id => companyApi.confirmCompanyNcc(id),
    onSuccess: async ({ nccVerified }, id) => {
      queryClient.setQueryData<Company>([QueryKey.GET_COMPANY, id], company =>
        company ? { ...company, nccVerified } : company
      );

      await queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_COMPANIES],
      });
    },
  });
};
